<div class="container relative size-4">
  <div class="overlay absolute size-4 bg-(--mat-sys-surface) flex items-center justify-center" [style.opacity]="opacity()">
    <mat-icon
      #filterTrigger="cdkOverlayOrigin"
      cdkOverlayOrigin
      class="colored-icon relative flex items-center justify-center"
      fontSet="material-icons-outlined"
      (click)="toggleFilter($event)"
    >
      filter_alt
    </mat-icon>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="filterTrigger"
  [cdkConnectedOverlayOpen]="showFilterDialog()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="closeFilterDialog()"
  (detach)="closeFilterDialog()"
>
  <mad-data-table-filter-dialog [filterOptions]="filterOptions()" [filterValue]="filterValue()" (filterChanged)="onFilterChanged($event)" />
</ng-template>
